import { NewsCategory } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategory";

export const newsSignalEventTrackingMap: Record<NewsCategory, string> = {
    [NewsCategory.Hires]: "hired new executive",
    [NewsCategory.Promotes]: "promoted existing executive",
    [NewsCategory.Leaves]: "executive left",
    [NewsCategory.Retires]: "executive retires",
    [NewsCategory.OpensNewLocation]: "opens new service location",
    [NewsCategory.ExpandsOfficesIn]: "expands existing offices",
    [NewsCategory.ExpandsOfficesTo]: "opens new offices",
    [NewsCategory.ExpandsFacilities]: "opens or expands facilities",
    [NewsCategory.SignsNewClient]: "signs new client",
    [NewsCategory.IncreasesHeadcountBy]: "increases headcount",
    [NewsCategory.AttendsEvent]: "attends event",
    [NewsCategory.Acquires]: "acquired other company",
    [NewsCategory.MergesWith]: "merges with other company",
    [NewsCategory.Launches]: "launches new offering",
    [NewsCategory.IntegratesWith]: "integrates with other company",
    [NewsCategory.IsDeveloping]: "begins development of offering",
    [NewsCategory.PartnersWith]: "partners with other company",
    [NewsCategory.EndsPartnershipWith]: "ends partnership with other company",
    [NewsCategory.SellsAssetsTo]: "sells assets to other company",
    [NewsCategory.IdentifiedAsCompetitorOf]: "identified as competitor",
    [NewsCategory.ReceivesFinancing]: "receives investment",
    [NewsCategory.InvestsInto]: "invests into other company",
    [NewsCategory.InvestsIntoAssets]: "invests into assets",
    [NewsCategory.GoesPublic]: "issues shares to the public",
    [NewsCategory.HasEarnings]: "reports earnings",
    [NewsCategory.HasRevenue]: "reports revenue",
    [NewsCategory.HasValuation]: "reports valuation",
    [NewsCategory.ClosesOffices]: "closes existing offices",
    [NewsCategory.DecreasesHeadcountBy]: "lays off employees",
    [NewsCategory.FilesSuitAgainst]: "files suit against other company",
    [NewsCategory.HasIssuesWith]: "vulnerability problems",
    [NewsCategory.DeclaresBankruptcy]: "declares bankruptcy",
    [NewsCategory.LosesClient]: "loses client",
    [NewsCategory.SpinsOffCompany]: "spins off company",
    [NewsCategory.SpinsOffDivision]: "spins off division",
    [NewsCategory.ReceivesAward]: "receives award",
    [NewsCategory.RecognizedAs]: "receives recognition",
};
